export const FORECAST_HOME_PAGE_TITLE: string = `EMARKETER Forecasts, Estimates, & Historical Data`;
export const FORECAST_SLUG_TITLE: string = `Forecasts, Estimates, & Historical Data`;

export const FORECAST_HOME_DESCRIPTION: string = `EMARKETER estimates and historical data. Visualize how digital trends are evolving using reliable and unbiased numbers.`;
export const FORECAST_DESCRIPTION = FORECAST_TITLE => {
   return `Get reliable, unbiased forecasts and estimates for ${FORECAST_TITLE} based on real historical data, market trends, and industry analyst insights."`;
};
